export default __webpack_public_path__ + "static/media/domains-zh.38e48545.svg";